import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./2.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 329.4 363.4"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            id="_1A_2223"
            data-name="1A_2223"
            points="224.3 63.3 239.1 63.3 239.1 90.5 213.6 90.5 213.6 68.6 224.3 68.6 224.3 63.3"
            fill="#231f20"
          />
          <polygon
            id="_1A_2222"
            data-name="1A_2222"
            points="198.2 63.4 212.8 63.4 212.8 90.5 187.3 90.5 187.3 68.6 198.2 68.6 198.2 63.4"
            fill="#231f20"
          />
          <polygon
            id="_1A_2207"
            data-name="1A_2207"
            points="108.2 97.7 134.4 97.7 134.4 119.6 122.9 119.6 122.9 124.8 108.1 124.8 108.2 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1A_2208"
            data-name="1A_2208"
            points="72.5 133.9 94.6 133.9 94.6 144.6 99.8 144.6 99.8 159.4 72.6 159.4 72.5 133.9"
            fill="#231f20"
          />
          <polygon
            id="_1A_2215"
            data-name="1A_2215"
            points="38.3 238 65.5 238 65.5 263.7 43.6 263.7 43.6 252.7 38.3 252.7 38.3 238"
            fill="#231f20"
          />
          <polygon
            id="_1A_2216"
            data-name="1A_2216"
            points="38.3 226.5 38.3 211.8 65.5 211.8 65.5 238 43.6 237.8 43.6 226.5 38.3 226.5"
            fill="#231f20"
          />
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            id="_1Bx_2201"
            data-name="1Bx_2201"
            points="265.3 97.7 291.5 97.7 291.5 124.9 280.3 124.9 280.3 129.1 265.3 129.1 265.3 97.7"
            fill="#231f20"
          />
          <rect
            id="_1C_2202"
            data-name="1C_2202"
            x="239.1"
            y="97.7"
            width="26.2"
            height="31.79"
            fill="#231f20"
          />
          <rect
            id="_1B_2203"
            data-name="1B_2203"
            x="212.9"
            y="97.5"
            width="26"
            height="27.32"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2204"
            data-name="1Bx_2204"
            points="186.7 97.7 212.9 97.7 212.9 124.8 201.7 124.8 201.7 129 186.7 129 186.7 97.7"
            fill="#231f20"
          />
          <rect
            id="_1C_2205"
            data-name="1C_2205"
            x="160.5"
            y="97.7"
            width="26.1"
            height="31.9"
            fill="#231f20"
          />
          <rect
            id="_1B_2206"
            data-name="1B_2206"
            x="134.4"
            y="97.7"
            width="26.2"
            height="27.14"
            fill="#231f20"
          />
          <rect
            id="_1B_2209"
            data-name="1B_2209"
            x="72.6"
            y="159.4"
            width="27.1"
            height="26.21"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2210"
            data-name="1Bx_2210"
            points="104.1 196.8 104.1 211.9 72.6 211.9 72.6 185.6 99.8 185.6 99.8 196.8 104.1 196.8"
            fill="#231f20"
          />
          <rect
            id="_1C_2211"
            data-name="1C_2211"
            x="72.6"
            y="211.9"
            width="31.9"
            height="26.11"
            fill="#231f20"
          />
          <rect
            id="_1B_2212"
            data-name="1B_2212"
            x="72.6"
            y="238"
            width="27.1"
            height="26.18"
            fill="#231f20"
          />
          <polygon
            id="_1Bx_2213"
            data-name="1Bx_2213"
            points="104.1 275.3 104.1 290.4 72.6 290.4 72.6 264.1 99.8 264.1 99.8 275.3 104.1 275.3"
            fill="#231f20"
          />
          <rect
            id="_1C_2214"
            data-name="1C_2214"
            x="72.6"
            y="290.4"
            width="31.9"
            height="26.18"
            fill="#231f20"
          />
          <polygon
            id="_1D_2219"
            data-name="1D_2219"
            points="80.4 71.9 92.2 60.1 96 63.9 107.4 63.9 107.4 90.5 100.2 90.5 92.7 98 77.2 82.5 84.1 75.6 80.4 71.9"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            id="_2Ax2_2221"
            data-name="2Ax2_2221"
            points="159.8 63.4 186.7 63.4 186.7 90.5 147.9 90.5 147.9 68.6 159.8 68.6 159.8 63.4"
            fill="#231f20"
          />
          <polygon
            id="_2Ax2_2220"
            data-name="2Ax2_2220"
            points="108.1 63.4 135.1 63.4 135.1 68.6 147 68.6 147 90.5 108.2 90.5 108.1 63.4"
            fill="#231f20"
          />
          <polygon
            id="_2A2_2218"
            data-name="2A2_2218"
            points="38.4 133.2 65.5 133.2 65.5 172.3 43.6 172.3 43.6 146.4 38.3 146.4 38.4 133.2"
            fill="#231f20"
          />
          <polygon
            id="_2Ax2_2217"
            data-name="2Ax2_2217"
            points="38.3 184.9 43.6 184.9 43.6 172.3 65.5 172.3 65.5 211.8 38.3 211.8 38.3 184.9"
            fill="#231f20"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(272.8 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2201
          </text>
          <text
            transform="translate(246 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2202
          </text>
          <text
            transform="translate(220 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2203
          </text>
          <text
            transform="translate(193.5 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2204
          </text>
          <text
            transform="translate(167.4 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2205
          </text>
          <text
            transform="translate(141.5 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2206
          </text>
          <text
            transform="translate(116.2 133.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2207
          </text>
          <text
            transform="translate(104.5 148.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2208
          </text>
          <text
            transform="translate(110 174.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2209
          </text>
          <text
            transform="translate(110 200.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2210
          </text>
          <text
            transform="translate(110 225.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2211
          </text>
          <text
            transform="translate(110 251.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2212
          </text>
          <text
            transform="translate(110 278.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2213
          </text>
          <text
            transform="translate(110 304.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2214
          </text>
          <text
            transform="translate(73.4 60.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2219
          </text>
          <text
            transform="translate(122.1 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2220
          </text>
          <text
            transform="translate(161.3 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2221
          </text>
          <text
            transform="translate(194 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2222
          </text>
          <text
            transform="translate(219.1 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2223
          </text>
          <text
            transform="translate(14 154.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2218
          </text>
          <text
            transform="translate(14 192.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2217
          </text>
          <text
            transform="translate(14 225.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2216
          </text>
          <text
            transform="translate(14 252.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2215
          </text>
          <text
            transform="translate(193.9 211.2)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            <tspan font-weight="700">2</tspan>
            <tspan
              x="5.1"
              y="0"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              楼
            </tspan>
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(272.8 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2201
          </text>
          <text
            transform="translate(246 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2202
          </text>
          <text
            transform="translate(220 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2203
          </text>
          <text
            transform="translate(193.5 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2204
          </text>
          <text
            transform="translate(167.4 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2205
          </text>
          <text
            transform="translate(141.5 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2206
          </text>
          <text
            transform="translate(116.2 133.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2207
          </text>
          <text
            transform="translate(104.5 148.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2208
          </text>
          <text
            transform="translate(110 174.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2209
          </text>
          <text
            transform="translate(110 200.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2210
          </text>
          <text
            transform="translate(110 225.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2211
          </text>
          <text
            transform="translate(110 251.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2212
          </text>
          <text
            transform="translate(110 278.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2213
          </text>
          <text
            transform="translate(110 304.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2214
          </text>
          <text
            transform="translate(73.4 60.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2219
          </text>
          <text
            transform="translate(122.1 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2220
          </text>
          <text
            transform="translate(161.3 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2221
          </text>
          <text
            transform="translate(194 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2222
          </text>
          <text
            transform="translate(219.1 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2223
          </text>
          <text
            transform="translate(14 154.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2218
          </text>
          <text
            transform="translate(14 192.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2217
          </text>
          <text
            transform="translate(14 225.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2216
          </text>
          <text
            transform="translate(14 252.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2215
          </text>
          <text
            transform="translate(186 211.2)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            2-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(272.8 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2201
          </text>
          <text
            transform="translate(246 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2202
          </text>
          <text
            transform="translate(220 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2203
          </text>
          <text
            transform="translate(193.5 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2204
          </text>
          <text
            transform="translate(167.4 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2205
          </text>
          <text
            transform="translate(141.5 138)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2206
          </text>
          <text
            transform="translate(116.2 133.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2207
          </text>
          <text
            transform="translate(104.5 148)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2208
          </text>
          <text
            transform="translate(110 174.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2209
          </text>
          <text
            transform="translate(110 200.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2210
          </text>
          <text
            transform="translate(110 225.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2211
          </text>
          <text
            transform="translate(110 251.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2212
          </text>
          <text
            transform="translate(110 278.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2213
          </text>
          <text
            transform="translate(110 304.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2214
          </text>
          <text
            transform="translate(73.4 60.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2219
          </text>
          <text
            transform="translate(122.1 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2220
          </text>
          <text
            transform="translate(161.3 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2221
          </text>
          <text
            transform="translate(194 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2222
          </text>
          <text
            transform="translate(219.1 55.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2223
          </text>
          <text
            transform="translate(14 154.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2218
          </text>
          <text
            transform="translate(14 192.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2217
          </text>
          <text
            transform="translate(14 225.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2216
          </text>
          <text
            transform="translate(14 252.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2215
          </text>
          <text
            transform="translate(181.6 211.2)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            2nd Floor
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/b/2.js